import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Skeleton,
  Stack,
} from '@mui/material';

const GroupDetailsSkeleton = () => {
  return (
    <Box height="100vh" display="flex" justifyContent="center" bgcolor="#f4f6f8" pb={5}>
      <Card sx={{ width: 900, height: '100%', display: 'flex', flexDirection: 'column' }}>
        {/* HEADER SKELETON */}
        <Box
          sx={{
            px: 2,
            py: 2,
            backgroundColor: '#e0e0e0',
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            {/* Back button */}
            <Skeleton variant="circular" width={40} height={40} />

            {/* Avatar */}
            <Skeleton variant="circular" width={72} height={72} />

            {/* Title + subtitle */}
            <Box flex={1}>
              <Skeleton variant="text" width="60%" height={28} />
              <Skeleton variant="text" width="40%" height={16} />
            </Box>
          </Stack>
        </Box>

        {/* CONTENT SKELETON */}
        <CardContent sx={{ flex: 1 }}>
          {/* Description */}
          <Skeleton variant="text" width="30%" height={20} />
          <Skeleton variant="rectangular" height={80} sx={{ mt: 1, borderRadius: 1 }} />

          {/* Members header */}
          <Skeleton variant="text" width="40%" height={28} sx={{ mt: 4 }} />

          {/* Members list */}
          {[1, 2, 3].map((i) => (
            <Box
              key={i}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                mt: 2,
                p: 2,
                border: '1px solid #e0e0e0',
                borderRadius: 2,
              }}
            >
              <Skeleton variant="circular" width={40} height={40} />
              <Box flex={1}>
                <Skeleton variant="text" width="50%" />
                <Skeleton variant="text" width="30%" />
              </Box>
              <Skeleton variant="circular" width={32} height={32} />
            </Box>
          ))}
        </CardContent>

        {/* FOOTER SKELETON */}
        <Box p={2} borderTop="1px solid #eee">
          <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rectangular" height={40} sx={{ mt: 1, borderRadius: 1 }} />
        </Box>
      </Card>
    </Box>
  );
};

export default GroupDetailsSkeleton;
